// @ts-nocheck
import InvoiceHistoryReducer, {
    InvoiceHistoryActions,
} from "@store/Framework/Store/Store/Pages/InvoiceHistory/InvoiceHistoryReducer";
import { combineReducers } from "redux";

const pagesReducers = combineReducers({
    invoiceHistory: InvoiceHistoryReducer,
});

export type PagesActions = InvoiceHistoryActions;

export default pagesReducers;
